import * as Sentry from '@sentry/browser';

// window.SENTRY_CONFIG é montado pelos layouts ERB (apenas em production/staging,
// com dados de current_customer/current_user). Sem config, nada inicializa —
// dev e test ficam sem Sentry.
export default function initSentry() {
  const config = window.SENTRY_CONFIG;
  if (!config || !config.dsn) return false;

  Sentry.init({
    dsn: config.dsn,
    ignoreErrors: [
      'NotAllowedError',
      "ReferenceError: Can't find variable: _AutofillCallbackHandler",
      "ReferenceError: Can't find variable: _pcmBridgeCallbackHandler",
      'zdassets.com',
    ],
  });

  if (config.source) Sentry.setTag('source', config.source);
  if (config.user) Sentry.setUser(config.user);

  return true;
}
